export const Images = {
  logoWhite: require('../../assets/Images/DCDDLogo.png'),
  logoBlack: require('../../assets/Images/DCDDLogo.png'),
  logoNdi: require('../../assets/Images/ndilogo.png'),
  defaultImage: require('../../assets/Images/ndilogo.png'),
  blankImage : require('../../assets/Images/blankImage.webp'),
  scanIcon : require('../../assets/Images/scanIcon.png'),
  noData : require('../../assets/Images/no-data.png'),
  noImage : require('../../assets/Images/noImage.jpeg'),
  ticketBanner : require('../../assets/Images/TicketBanner.png'),
  royalHeritage : require('../../assets/Images/RoyalHeritage.png'),
  nationalMuseum : require('../../assets/Images/NationalMuseum.png'),
  dummyQr : require('../../assets/Images/dummyQr.jpg'),
};
